import { httpClient } from './httpClient'

export interface LocaleDto {
  language: string
}

/** Resolves the visitor's Accept-Language header against the supported languages server-side. */
export const localeApi = {
  get: () => httpClient.get<LocaleDto>('/locale'),
}
